import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function Pageview() {
  const { pathname } = useLocation();
  // The Rails app and Google Tag Manager handle initial setup of GA. Continue to use
  // it for the initial pageview and library setup and only record future SPA pageviews here.
  const [initialPageLoaded, setInitialPageLoaded] = useState(false);

  useEffect(() => {
    let observer;
    if (initialPageLoaded) {
      observer = new MutationObserver(() => {
        // Broadcast an event with the new pathname - used by usePathname hook
        const appPageViewEvent = new CustomEvent(
          'appPageView',
          {
            detail: { pathname }
          }
        );
        document.dispatchEvent(appPageViewEvent);

        // Google Analytics
        if ((window as any).dataLayer) {
          (window as any).dataLayer.push({ event: 'page_view' });
        }

        // Mixpanel
        if ((window as any).mixpanel) {
          const eventProperties = {
            host: window.location.hostname,
            path: window.location.pathname
          };
          (window as any).mixpanel.track('Page Viewed', eventProperties);
        }
      })

      // If we track the pathname only then the PageView event gets sent with the old page title.
      observer.observe(document.querySelector('title'), { childList: true });
    }

    setInitialPageLoaded(true);
    return () => observer?.disconnect();
  }, [pathname]);

  return null;
};
